import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { UserPhoto } from "../../../@types/usePhotoGallery";
import { RootState } from "../../rootReducer";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const sendPhoto = createAsyncThunk(
  "uploadPhotoHC",
  async (fileToUpload: UserPhoto[], { rejectWithValue, getState }) => {
    const state = getState() as RootState;

    const idHc = state.qrScanner.qrCode;

    const id: any = idHc.split("hc").pop();

    if (fileToUpload.length > 0) {
      let imageToBlob = await fetch(fileToUpload[0].webviewPath!).then((r) => r.blob());

      var file = new File([imageToBlob], fileToUpload[0].filepath, {
        type: "image/jpeg",
      });

      console.log(file);

      const formData = new FormData();
      formData.append("image", file);

      const { data: dataResponse } = await axiosInstance.post(
        `${api.hojasDeCargoURL}hojacargo/uploadMobile?hc=${parseInt(id)}`,
        formData
      );
    }
    return Response;
  }
);
